const isEnabled = () => {
  return import.meta.env.VITE_ENABLE_DEVTOOLS === "true";
};

export const shouldEnableDevtools = (): boolean => {
  return isEnabled();
};
